// src/components/CartBar.js
import React, { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";

const CartBar = ({ onCartClick }) => {
  const [cart, setCart] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const cartData = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(cartData);

    let qty = 0;
    let price = 0;

    cartData.forEach((item) => {
      qty += item.quantity;
      price += item.total;
    });

    setTotalQty(qty);
    setTotalPrice(price);
  }, []);

  // if (totalQty === 0) return null;

  return (
    <div
      onClick={onCartClick}
      style={{zIndex:"100"}}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[90%] max-w-md bg-black text-white shadow-xl rounded-2xl flex items-center justify-between px-4 py-3 cursor-pointer transition hover:shadow-2xl"
    >
      <div className="flex items-center gap-3">
        <div className="relative">
          <ShoppingCart className="w-6 h-6 text-white cart-icon" />
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
            {totalQty}
          </span>
        </div>
        <span className="font-medium">
          {totalQty} {totalQty === 1 ? "item" : "items"}
        </span>
      </div>

      <div className="bg-gray-800 text-white font-semibold px-4 py-2 rounded-xl shadow-md">
           {localStorage.getItem('currency')} {totalPrice.toFixed(2)}
      </div>
    </div>
  );
};

export default CartBar;
